import { BeneficiaryPerformanceType } from "@/types/beneficiaries";

interface PerformanceDataPoint {
  date: string;
  value: number;
  valueDate: string;
}

export const useBeneficiaryPerformanceData = (
  performanceData: BeneficiaryPerformanceType
): PerformanceDataPoint[] => {
  if (
    !performanceData ||
    !performanceData.statDetails ||
    performanceData.statDetails.length === 0
  ) {
    return [];
  }

  const statDetails = performanceData.statDetails;
  const chartData: PerformanceDataPoint[] = [];

  statDetails.forEach((month) => {
    const fromDate = new Date(month.from);
    const formattedDate = `${fromDate.getFullYear()}-${String(
      fromDate.getMonth() + 1
    ).padStart(2, "0")}`; // YYYY-MM

    chartData.push({
      date: formattedDate,
      value: month.totalCredit,
      valueDate: month.from,
    });
  });

  chartData.sort(
    (a, b) => new Date(a.valueDate).getTime() - new Date(b.valueDate).getTime()
  );

  const uniqueMonthlyData: PerformanceDataPoint[] = [];
  const monthMap = new Map<string, PerformanceDataPoint>();

  chartData.forEach((point) => {
    const existing = monthMap.get(point.date);
    if (!existing || new Date(point.valueDate) > new Date(existing.valueDate)) {
      monthMap.set(point.date, point);
    }
  });

  uniqueMonthlyData.push(...Array.from(monthMap.values()));
  uniqueMonthlyData.sort((a, b) => a.date.localeCompare(b.date));

  return uniqueMonthlyData;
};
